import { likeComment, postComment } from './spica/functions/Article';
import { login, deactivateAccount } from './spica/functions/Auth';

interface IFunction {
  login(token: string): Promise<any>;
}

class FunctionService implements IFunction {
  project = process.env.REACT_APP_PROJECT_CODE;

  login(token: string) {
    return login({
      data: { project: this.project, token },
    });
  }

  likeComment(user_id: string, comment_id: string) {
    return likeComment({
      data: {
        user_id,
        comment_id,
        project: this.project
      },
    });
  }

  postComment(
    user_id: string,
    message: string,
    article_id: string,
    main_comment_id?: string,
    reply_to_comment_id?: string
  ) {
    return postComment({
      data: {
        user_id,
        message,
        article_id,
        main_comment_id,
        reply_to_comment_id,
        project: this.project
      },
    });
  }

  deactivateAccount(token: string) {
    return deactivateAccount({ data: { project: this.project, token } })
  }
}

const fnService = new FunctionService();
export default fnService;
